<mat-card class="example-card">
  <mat-card-header class="titreFrm">
    <mat-card-title>MA NOTE DE FRAIS</mat-card-title>
  </mat-card-header>
  <mat-card-content class="border">
    <div *ngIf="exist; else attente"></div>
    <ng-template #attente>
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </ng-template>
    <mat-card>
      <mat-card-content>
        <div class="displayFlex">
          <div>
            <mat-form-field appearance="outline">
              <mat-label>Mois</mat-label>
              <mat-select
                placeholder="Mois"
                [(ngModel)]="mois"
                (selectionChange)="afficherFrais()"
              >
                <mat-option
                  *ngFor="let mois of moisTab; let i = index"
                  [value]="i"
                  >{{ mois }}</mat-option
                >
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Année</mat-label>
              <mat-select
                placeholder="Année"
                [(ngModel)]="annee"
                (selectionChange)="afficherFrais()"
              >
                <mat-option *ngFor="let annee of anneeTab" [value]="annee">{{
                  annee
                }}</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Collaborateurs</mat-label>
              <mat-select
                placeholder="Collaborateurs"
                [(ngModel)]="collaborateur.Perso_Matricule"
                (selectionChange)="afficherFrais()"
              >
                <mat-option
                  *ngFor="let Perso of listeCollaborateurs"
                  [(ngModel)]="Perso.Perso_Matricule"
                  >{{ Perso.Perso_Nom }}</mat-option
                >
              </mat-select>
            </mat-form-field>
          </div>
          <div>
            <button
              [disabled]="!exist"
              mat-raised-button
              class="colorGreen"
              (click)="afficherFrais()"
            >
              <mat-icon>search</mat-icon>Afficher
            </button>
            <button
              [disabled]="!exist"
              mat-raised-button
              class="colorGreen"
              (click)="enregistrer()"
            >
              <mat-icon>save</mat-icon>Enregistrer
            </button>
            <button
              [disabled]="!exist"
              type="button"
              (click)="exportToExcel()"
              mat-raised-button
              class="colorGreen"
            >
              <mat-icon>arrow_downward</mat-icon>Export Excel
            </button>
          </div>
        </div>
        <app-avt-listes
          #listeFraisComponen
          [api]="generalService.api"
          [heightTable]="'400'"
          [dataSourceBrut]=""
          [displayedColumnsBrut]="columns"
          (outputAction)="outputAction($event)"
        >
        </app-avt-listes>
      </mat-card-content>
    </mat-card>
  </mat-card-content>
</mat-card>
